export default "assets/images/icons/entity-grapes-3ca55460.svg";